const BackgroundDecoration = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden -z-10">
      {/* Subtle gradient orbs */}
      <div 
        className="absolute top-0 -left-32 w-[500px] h-[500px] bg-gradient-to-br from-foreground/[0.02] via-transparent to-transparent rounded-full blur-3xl"
      />
      <div 
        className="absolute top-1/3 -right-32 w-[400px] h-[400px] bg-gradient-to-bl from-muted-foreground/[0.03] via-transparent to-transparent rounded-full blur-3xl"
      />
      
      {/* Subtle dot grid */}
      <div 
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: `radial-gradient(circle, hsl(var(--foreground)) 0.5px, transparent 0.5px)`,
          backgroundSize: '24px 24px'
        }}
      />
    </div>
  );
};

export default BackgroundDecoration;
